exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".caregivers{padding:15px}.caregivers h2{margin-bottom:15px}.caregivers .caregiver{margin-bottom:15px;position:relative}.caregivers .caregiver .add-caregiver{text-align:center}.caregivers .caregiver a{color:inherit;text-decoration:none;cursor:pointer}.caregivers .caregiver .delete-button-icon{position:absolute;top:15px;right:15px;color:#e96f6f;cursor:pointer;font-size:1.5em}.caregivers .caregiver .delete-button-icon:hover{color:#f79494}.caregivers .subtitle{font-weight:400;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/CaregiverList/CaregiverList.scss
// module id = 585
// module chunks = 0